import * as Spinner from "react-spinners";
import {useContext} from "react";
import {TravelThemeContext} from "./index";


export default function Loader(props)
{
    const context=useContext(TravelThemeContext)
    return(
        <div style={{backgroundColor:"rgba(255,255,255,.92)",position:"fixed",zIndex:10000,top:0,left:0,right:0,bottom:0,width:"100vw",height:"100vh",display:"flex",alignItems:"center",justifyContent:"center"}}>
            <Spinner.MoonLoader
                color={context?.travel?.theme?.primaryColor || "#162127"}
                loading={true}
                size={80}
                aria-label="Loading Spinner"
                data-testid="loader"
                speedMultiplier={1}
            />
        </div>
    )
}
